// extracted by mini-css-extract-plugin
export var base = "GridContainer-module--base--4bdea";
export var columns12 = "GridContainer-module--columns-12--70011";
export var columns3 = "GridContainer-module--columns-3--9441a";
export var columns4 = "GridContainer-module--columns-4--5906f";